import { FC } from 'react';
import { clsx } from 'clsx';

import { IDateCardProps } from '../models/types';

import styles from './styles.module.scss';

export const DateCard: FC<IDateCardProps> = ({ data }) => {
  return (
    <div
      className={clsx([styles['date-card']], {
        [styles['date-card__primary']]: data.isPrimary,
      })}
    >
      <div className={styles['date-card__section-1']}>
        <span className={styles['date-card__date']}>{data.date}</span>
        <span className={styles['date-card__lesson-quantity']}>
          {' '}
          — {data.lessonQuantity}
        </span>
      </div>
      <div className={styles['date-card__section-2']}>
        <span className={styles['date-card__time-interval']}>
          {data.timeInterval}
        </span>
        {data.timeInterval.length !== 0 && (
          <div className={styles['date-card__section-2-delimiter']}></div>
        )}
        <span className={styles['date-card__week-parity']}>
          {data.weekParity}
        </span>
      </div>
    </div>
  );
};
